/**
 * pair-offer-note.js — "2nd print offer active" strip on customizer pages.
 *
 * The cart's offer rail shows halved second-print prices, but a customer who
 * clicks through used to land on a customizer showing full price with no
 * mention of the offer until checkout. When the cart holds an ODD number of
 * eligible print units (same pair-open rule as the rail: the next print
 * completes a pair and gets the automatic print-portion BOGO), this inserts
 * a one-line note next to the customizer's price.
 *
 * Deliberately a NOTE, not a recalculated price: the discount lands on the
 * lower-priced print of the pair, so a per-size struck price computed here
 * could overstate the saving when the new print is the dearer one.
 *
 * Placement is inline with each customizer's price element (scrolls with the
 * controls, never covers the preview or the CTA); the moon customizer's
 * price lives in its sticky footer, so there the note becomes a slim
 * full-width line at the top of that bar.
 */
(function () {
  'use strict';
  if (window.__pairOfferNoteLoaded) return;
  window.__pairOfferNoteLoaded = true;

  // Edit / resume / preset / claim sessions are not "adding one more print":
  // an edit confirm REPLACES the counted line, so the pair maths would lie.
  var params = new URLSearchParams(window.location.search);
  if (params.get('order_id') || params.get('saved') || params.get('preset') || params.get('claim')) return;

  // The customizer's price element. The note becomes a rounded pill sitting
  // in a flex row to the RIGHT of it (wrapping below on narrow screens).
  var ANCHORS = [
    '#sm2-price',                 // star map v2 (finish step)
    '#lm-price',                  // location map
    '#price-display',             // custom print
    '.cust-footer-price-text',    // moon (sticky footer price)
    '.h-add__cart--price p'       // family moon
  ];

  // Short enough to sit beside the price on a 390px phone; the precise
  // wording (lower-priced print, print portion) lives on the cart rail
  // footnote and at checkout.
  var NOTE_TEXT = '2nd print offer: 50% off at checkout';

  function eligibleUnits(cart) {
    var units = 0;
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (!(p._OrderID || p.OrderID)) return;
      var t = (it.product_title || it.title || '').toLowerCase();
      if (t.indexOf('enhancement') !== -1 || t.indexOf('upscale') !== -1) return;
      units += Number(it.quantity) || 0;
    });
    return units;
  }

  // Canvas is a separate product line: it counts towards a BOGO pair but is
  // never the leg that gets 50% off, so the note would be a lie on a canvas
  // selection. Every customizer keeps its live variant id in a [name="id"]
  // input (#sm2-variant-id, #lm-variant-id, #var_id, #h-var_id, or the
  // hidden product-select), which is the one thing they all share.
  var VARIANT_INPUTS = '#sm2-variant-id,#lm-variant-id,#var_id,#h-var_id,[name="id"]';

  function canvasSelected() {
    var ids = window.SkylitCanvasVariantIds;
    if (!ids || !ids.length) return false;
    var nodes = document.querySelectorAll(VARIANT_INPUTS);
    for (var i = 0; i < nodes.length; i++) {
      var v = String(nodes[i].value || '').trim();
      if (!v) continue;
      for (var j = 0; j < ids.length; j++) {
        if (String(ids[j]) === v) return true;
      }
      // First control carrying a real id wins; a stale second one must not
      // override it.
      return false;
    }
    return false;
  }

  function buildNote() {
    var el = document.createElement('span');
    el.className = 'pair-offer-note';
    el.setAttribute('role', 'note');
    el.style.cssText =
      'display:inline-flex;align-items:center;max-width:100%;box-sizing:border-box;' +
      'padding:4px 11px;background:#f3ecdd;color:#8b6914;border-radius:999px;' +
      'font-size:10.5px;line-height:1.3;font-family:\'Josefin Sans\',system-ui,sans-serif;';
    el.textContent = NOTE_TEXT;
    return el;
  }

  // The finish can be switched at any point in the wizard, so the pill's
  // visibility is re-evaluated on a slow poll rather than assumed at insert.
  function watchFinish(el) {
    function sync() { el.style.display = canvasSelected() ? 'none' : 'inline-flex'; }
    sync();
    setInterval(sync, 600);
  }

  function tryInsert() {
    if (document.querySelector('.pair-offer-note')) return true;
    for (var i = 0; i < ANCHORS.length; i++) {
      var target = document.querySelector(ANCHORS[i]);
      if (!target || !target.parentNode) continue;
      // Wrap the price element and the pill in one flex row so the pill
      // sits to the right of the price, wrapping below on narrow screens.
      // Moving the node keeps every JS reference to it valid.
      var row = document.createElement('div');
      row.className = 'pair-offer-row';
      row.style.cssText = 'display:flex;align-items:center;gap:8px;flex-wrap:wrap;min-width:0;';
      target.parentNode.insertBefore(row, target);
      row.appendChild(target);
      var note = buildNote();
      row.appendChild(note);
      watchFinish(note);
      return true;
    }
    return false;
  }

  function boot() {
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (eligibleUnits(cart) % 2 !== 1) return;
        // Customizer panels build late (wizard steps, deferred engines) —
        // poll for an anchor rather than assuming it exists at load.
        if (tryInsert()) return;
        var tries = 0;
        var timer = setInterval(function () {
          tries++;
          if (tryInsert() || tries > 15) clearInterval(timer);
        }, 800);
      })
      .catch(function () { /* the note is a nicety, never an error */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
